import { LogLevel } from "@/utils/Enum";
import Logger from "@/utils/Logger";

/**
 * Initialize logger with environment-appropriate settings
 * This is optional - logger works with defaults if not called
 */
export const initializeLogger = (): void => {
  const isDev = process.env.NODE_ENV === "development";
  const isTest = process.env.NODE_ENV === "test";

  Logger.configure({
    // Development: Show all logs
    // Production: Only warnings and errors
    // Test: Minimal logging
    level: isTest ? LogLevel.ERROR : isDev ? LogLevel.DEBUG : LogLevel.WARNING,
    enableConsole: !isTest, // Disable in tests to reduce noise
    prefix: isDev ? "[SCRM-UI]" : "", // Prefix only in development
  });

  if (isDev) {
    Logger.info("Logger initialized for development environment", [
      "LoggerConfig",
    ]);
  }
};

/**
 * Quick setup for different environments
 */
export const setupDevelopmentLogging = (): void => {
  Logger.configure({
    level: LogLevel.DEBUG,
    enableConsole: true,
    prefix: "[DEV]",
  });
};

export const setupProductionLogging = (): void => {
  Logger.configure({
    level: LogLevel.WARNING,
    enableConsole: true,
    prefix: "",
  });
};

export const setupTestLogging = (): void => {
  Logger.configure({
    level: LogLevel.ERROR,
    enableConsole: false,
    prefix: "",
  });
};
